import give_outs from './give_outs'

export default {
    namespaced: true,

    modules: {
        give_outs
    }
}